module.exports = __webpack_public_path__ + "img/2010.11-1.51d2e39d.jpg";